"use client";

import { get, set, del } from "idb-keyval";
import type { ResumeDocument } from "@/types/cv";
import type { ResumeTemplateId } from "@/lib/cv/template";

// Unauthenticated builder drafts live in IndexedDB so a visitor can build a CV
// from their phone without signing in, then have it rehydrated after login to
// download or run the ATS review. Mirrors the cv-upload pattern in indexed-db.ts.
const STORAGE_KEY = "cv-builder-draft";

export type CvBuilderDraft = {
  resume: ResumeDocument;
  templateId: ResumeTemplateId;
  // Set when the visitor finished the form and was sent to sign-in to download.
  // On rehydrate, the result step is shown straight away.
  ready: boolean;
  updatedAt: string;
};

const isDraft = (value: unknown): value is CvBuilderDraft =>
  typeof value === "object" &&
  value !== null &&
  "resume" in value &&
  "templateId" in value;

export const getDraft = async (): Promise<CvBuilderDraft | undefined> => {
  const stored = await get<unknown>(STORAGE_KEY);
  return isDraft(stored) ? stored : undefined;
};

export const saveDraft = (draft: CvBuilderDraft): Promise<void> =>
  set(STORAGE_KEY, draft);

export const deleteDraft = (): Promise<void> => del(STORAGE_KEY);
